import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Link from '@mui/material/Link';
import { Avatar, IconButton, Stack, Tooltip } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'; 
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import DashboardIcon from '@mui/icons-material/Dashboard';
import {signOut} from 'aws-amplify/auth'
import RunCircleIcon from '@mui/icons-material/RunCircle';
import UserProfileDialog from './UserProfileDialog';

const SIMULATOR_URL = process.env.REACT_APP_SIMULATOR_URL;


export default function CabbAppBar(props: {
  email: string,
  authorised: boolean,
  refreshUser: () => void
}) {

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openUserProfile, setOpenUserProfile] = React.useState(false);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    props.refreshUser();
  };

  const handleLogout = () => {
    signOut();
  }

  const handleCloseUserProfileDialog = () => {
    setOpenUserProfile(false);
  }

  const handleOpenUserProfileDialog = () => {
    setOpenUserProfile(true);
    handleClose();
  }

  return (
    <React.Fragment>
      <UserProfileDialog
        open = {openUserProfile}
        handleClose = {handleCloseUserProfileDialog}
        email ={props.email}
      ></UserProfileDialog>
      <AppBar position="static" 
        sx={{
          backgroundRepeat: 'no-repeat',
          height: '74px',
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: '#004B87',
          flexDirection: 'row'
        }}>
        <Toolbar sx={{
          backgroundRepeat: 'no-repeat',
          height: '74px',
          width: 'calc(100% - 20px)',
          padding: '0 !important',
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#004B87'
        }}>
          <a href="https://www.atnf.csiro.au/" target="_blank" rel="noreferrer"
            title="ATNF Home" id="logo">
              <img src="./logo.png" alt="csiro logo" height={'65px'}/>
          </a>
          
          <Link href="/"
            underline="none" sx={{
            color: 'white',
            fontSize: '150%',
          }}
          >
            ATCA BIGCAT Scheduler
          </Link>

          <Stack direction={'row'} spacing={3} alignItems={'center'}>
            <Tooltip title="Goto Daskboard">
              <IconButton aria-label="dashboard" size="large"
                href="/"
                sx={{color: 'whitesmoke'}} >
                <DashboardIcon />
              </IconButton>
            </Tooltip>

            {props.authorised &&
              <IconButton aria-label="profile" size="medium"
                onClick={handleMenu}>
                <Avatar
                  sx={{
                    fontSize: '100%',
                    width: 40, height: 40,
                    bgcolor: blueGrey[500],
                    "&:hover": {
                      cursor: 'pointer',
                      bgcolor: blueGrey[100],
                    }
                  }}
                >
                  {
                      props.email ? props.email.charAt(0).toUpperCase() : ''
                  }
                </Avatar>
              </IconButton>
            }
          </Stack>
          
          <Menu
            PaperProps={{ sx: {width: 200}}}
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: -55,
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {props.authorised &&
            <MenuItem onClick={handleOpenUserProfileDialog}>
              <ListItemIcon>
                <ManageAccountsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Profile</ListItemText>
            </MenuItem>
            }

            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </Menu>

        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
}